module.exports = __webpack_public_path__ + "img/image_3-36a061aa.png";